import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getBlogPosts } from "../../../firebase/blogServices";
import { FaArrowRight } from "react-icons/fa";
import "./LatestPosts.css";
import { slugify } from "../../../utils/slugify";

const LatestPosts = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLatestPosts = async () => {
      try {
        const allPosts = await getBlogPosts();
        // Get only the latest 3 posts
        const latestPosts = allPosts.slice(0, 3);
        setPosts(latestPosts);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching latest blog posts:", err);
        setError("Não foi possível carregar os artigos mais recentes.");
        setLoading(false);
      }
    };

    fetchLatestPosts();
  }, []);

  // Format date to Brazilian format
  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  // Truncate text to a specific length
  const truncateText = (text, maxLength) => {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    return text.substr(0, maxLength) + "...";
  };

  return (
    <section className="latest-posts-section" id="latest-posts">
      <div className="latest-posts-container">
        <div className="latest-posts-header">
          <h2 className="latest-posts-title">Blog</h2>
          <p className="latest-posts-subtitle">
            Confira nossos artigos mais recentes sobre tecnologia e
            desenvolvimento
          </p>
        </div>

        {loading ? (
          <div className="latest-posts-loading">
            <div className="loading-spinner"></div>
            <p>Carregando artigos...</p>
          </div>
        ) : error ? (
          <div className="latest-posts-error">
            <p>{error}</p>
          </div>
        ) : (
          <>
            <div className="latest-posts-grid">
              {posts.map((post, index) => (
                <Link
                  to={`/blog/${slugify(post.title)}`}
                  className="latest-post-card"
                  key={post.id}
                  style={{ "--card-index": index + 1 }}
                >
                  <div className="latest-post-image">
                    <img
                      src={post.imageUrl || "/images/blog-placeholder.jpg"}
                      alt={post.title}
                      onError={(e) => {
                        e.target.src = "/images/blog-placeholder.jpg";
                      }}
                    />
                  </div>
                  <div className="latest-post-content">
                    <span className="latest-post-date">
                      {formatDate(post.createdAt)}
                    </span>
                    <h3 className="latest-post-title">{post.title}</h3>
                    <p className="latest-post-excerpt">
                      {truncateText(post.excerpt || post.content, 100)}
                    </p>
                    <span className="latest-post-link">
                      Ler mais <FaArrowRight />
                    </span>
                  </div>
                </Link>
              ))}
            </div>

            <div className="latest-posts-more">
              <Link to="/blog" className="view-all-button">
                Ver todos os artigos
              </Link>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default LatestPosts;
